// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"d8b17192","754":"72242014","891":"798e63d8","4020":"f28e7c8d","4840":"ebf5d7b5","8829":"0dc1a2f8"}[chunkId] + ".chunk.css";
};